import { Link } from "gatsby";
import React from "react";

import Facebook from "../../assets/facebook-min.svg";
import Instagram from "../../assets/instagram-min.svg";
import Linkedin from "../../assets/linkedin-min.svg";
import Logo from "../../assets/logo-and-text.svg";
import Tiktok from "../../assets/tiktok-min.svg";
import Twitter from "../../assets/twitter-min.svg";
import PlayStore from "../../assets/download-play-store-min.svg";
import AppStore from "../../assets/app-store-download-min.svg";

interface Props {
  className?: string;
}
export const Footer = ({ className }: Props) => {
  return (
    <footer className={`footer ${className ? className : ""}`}>
      <div className="footer__body">
        <div className="footer__box">
          <img className="logo" src={Logo} alt="Flahmingo Investments Inc" />
          <section className="footer__socials">
            <a
              className="footer__social"
              href="https://ca.linkedin.com/company/flahmingo"
              target="_blank"
            >
              <img src={Linkedin} alt="Linkedin" />
            </a>
            <a
              className="footer__social"
              href="https://www.facebook.com/askflahmingo/"
              target="_blank"
            >
              <img src={Facebook} alt="Facebook" />
            </a>
            <a
              className="footer__social"
              href="https://www.instagram.com/askflahmingo"
              target="_blank"
            >
              <img src={Instagram} alt="Instagram" />
            </a>
            <a
              className="footer__social"
              href="https://www.tiktok.com/@askflahmingo"
              target="_blank"
            >
              <img src={Tiktok} alt="Tiktok" />
            </a>
            <a
              className="footer__social"
              href="https://twitter.com/askflahmingo"
              target="_blank"
            >
              <img src={Twitter} alt="Twitter" />
            </a>
          </section>
          <div className="footer__col__contact">
            <a href="mailto:hello@flahmingo.com">hello@flahmingo.com</a>
            <p>Calgary, Canada</p>
          </div>
        </div>
        <div>
          <Link className="footer__link" to="/legal/privacy-policy/">
            Privacy Policy
          </Link>
          <Link className="footer__link" to="/legal/terms-and-conditions/">
            Terms and Conditions
          </Link>
          <Link
            className="footer__link"
            to="/legal/complaint-handling-process/"
          >
            Complaint Handling Process
          </Link>
        </div>
        <div>
          <Link className="footer__link" to="/fees-schedule/">
            Fee Schedule
          </Link>
          <Link
            className="footer__link"
            to="https://help.flahmingo.com/hc/en-us"
          >
            Frequently Asked Questions
          </Link>
          <Link className="footer__link" to="https://flahmingo.applytojobs.ca/">
            Careers
          </Link>
        </div>
        <div className="footer__stores">
          <a href="https://play.google.com/store/apps/details?id=development.flahmingo.app">
            <img src={PlayStore} alt="PlayStore Logo" />
          </a>
          <a href="https://apps.apple.com/ca/app/flahmingo/id1529127053">
            <img src={AppStore} alt="AppStore Logo" />
          </a>
        </div>
      </div>
      <p className="footer__copyright">
        © Copyright 2024 Flahmingo Investments Inc. All Rights Reserved.
        <br></br>
        Securities are offered to clients by Flahmingo Investments Inc.
        (“Flahmingo”), a registered restricted dealer in Alberta. This is not an
        offer, distribution, solicitation of an offer or advice to buy or sell
        securities or open a self-directed Tax-Free Savings Account (“TFSA”) in
        any jurisdiction where Flahmingo is not registered. Securities offered
        by Flahmingo are not Canadian Investor Protection Fund insured. The
        broker-dealer used by Flahmingo in the United States is a member of the
        Securities Investor Protection Corporation. However, Flahmingo does not
        represent or warrant whether protection may be available to our clients
        in Canada. Commission-free trading of securities refers to $0
        commissions for Flahmingo self-directed individual TFSAs that trade U.S.
        listed securities, including fractional shares. Keep in mind that other
        fees such as foreign exchange fees and paper statement fees may apply to
        your self-directed TFSA. Please see our&nbsp;
        <a className="footer__flahcolor" href="/fees-schedule/">
          Fee Schedule.
        </a>
        <br></br>
        <br></br>
        All investments involve the risk of loss, and the past performance of a
        security or a financial product does not guarantee future results or
        returns. Clients should be aware that system response, execution price,
        speed, liquidity, market data, and account access times are affected by
        many factors, including market volatility, size and type of order,
        market conditions, system performance, and other factors. These risks
        are to be assumed by the client. Clients should consider the investment
        objectives and unique risk profile of Exchange Traded Funds (ETFs)
        carefully before investing. ETFs are subject to risks similar to those
        of other diversified portfolios. Leveraged and Inverse ETFs may not be
        suitable for all clients and may increase exposure to volatility through
        the use of leverage, short sales of securities, derivatives and other
        complex investment strategies. Third-party information provided for
        Flamingo’s marketing communications emanating from its social media
        community, market prices, data and other information available through
        Flahmingo are meant for informational purposes only and are not intended
        as an offer or solicitation for the purchase or sale of any financial
        instrument or as an official confirmation of any transaction. The
        information provided is not warranted as to completeness or accuracy and
        is subject to change without notice.
      </p>
    </footer>
  );
};
